<template>
  <div class="container">
    <div class="img-container">
      <img style="height: 80%; width: 80%" src="./img/icons8-chatgpt-480.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatAIBox'
}
</script>

<style scoped>
@import './css/variables.css'; /* 导入参数文件 */
.container {
  height: var(--nav-height);
  width: var(--nav-height);
}
.img-container {
  margin: auto;
  height: 100%;
  width: 100%;
  background-color: var(--primary-color-b-rgb);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
}
.container :hover {
  background-color: #3a2787;
}
</style>
